import React from "react";

const ChartCard = ({ title, data }) => {
	return (
		<>
			<div className="chart-wrapper">
				{title && <h4 className="text-base title">{title}</h4>}
				<Chart data={data} />
			</div>
		</>
	);
};

export const Chart = ({ data }) => {
	const { dataSet, label } = data;
	const maxValue = Math.max(...dataSet);
	const total = Math.ceil(dataSet.reduce((a, b) => a + b, 0));
	console.log(maxValue);
	return (
		<>
			<div className="chart">
				<div className="yaxis">
					<div>
						<span>{maxValue}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>{(maxValue * 5) / 6}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>{(maxValue * 4) / 6}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>{(maxValue * 3) / 6}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>{(maxValue * 2) / 6}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>{(maxValue * 1) / 6}</span>
						<span className="border"></span>
					</div>
					<div>
						<span>0</span>
						<div className="border">
							<div className="xaxis">
								<div className="xaxis-data-bars">
									{label &&
										label.map((item, i) => (
											<span
												className="item"
												key={i}
												style={{
													height:
														(dataSet[i] / maxValue) * 100 + "%",
												}}
											></span>
										))}
								</div>
								<div className="xaxis-data">
									{label &&
										label.map((item, i) => (
											<span className="item" key={i}>
												{item}
											</span>
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ChartCard;
